"use strict";

angular.module("core")
.constant("PRE_AUTHORIZED_PAYMENT_AGREEMENT_TYPES", {
    "NONE": "",
    "MANDATORY": "mandatory",
    "OPTIONAL": "optional"
}).constant("PAYMENT_METHODS", {
    "BANK_TRANSFER": "bank_transfer",
    "CREDIT_CARD": "credit_card"
});



//////////////////
// WEBPACK FOOTER
// ./core/payment-methods/payment-methods.constants.js
// module id = 395
// module chunks = 0